import { css } from '@emotion/css';

import { cn } from '@lyearn/style';
import { AccordionDetails } from '@lyearn/ui';

type Props = React.ComponentProps<typeof AccordionDetails>;

const accordionDetailsStyles = css`
  &.MuiAccordionDetails-root {
    padding: 0;
  }
`;

const AccordionDetailsComponent: React.FC<Props> = (props) => {
  const { classes, className, ...rest } = props;

  return <AccordionDetails className={cn(accordionDetailsStyles, className)} {...rest} />;
};

export default AccordionDetailsComponent;
